import { useEffect } from "react";
import { MultiStepItemProps } from "@ucl/library";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import { SelectProductForm } from "./SelectProductForm";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";

export interface SelectProductFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const SelectProductFormStep: React.FC<SelectProductFormStepProps> = (props) => {
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);
  
  useEffect(() => {
    props.registerSubmit?.(async () => {
      return true;
    });
  }, [props.financialApplicationId]);

  return (
    <SelectProductForm
      apiClient={financialApplicationApiClient}
      financialApplicationId={props.financialApplicationId}
    />
  );
};
